export const SET_ERROR_KEY = "SET_ERROR_KEY";
export const INCREASE_ERROR_VALUE = "INCREASE_ERROR_VALUE";
